import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"currentColor\" id=\"icon-arrow-right\">\n  <path d=\"M6.46042 3.54004L5.54119 4.45928L9.08157 7.99966L5.54119 11.54L6.46042 12.4593L10.92 7.99966L6.46042 3.54004Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol